import { TestimonialsData } from '../../types';

export const TESTIMONIALS_DATA: TestimonialsData = {
  background_colour: '#f5f5f5',
  testimonials: [
    {
      organisation_name: 'Lucy & Yak',
      organisation_website_link: 'https://lucyandyak.com/',
      organisation_offset_earth_username: 'lucyandyak',
      person_name: 'via Instagram',
      testimony: "Ecologi is one of the most exciting things we've discovered this year!",
      image: {
        url: 'https://cms-assets.offset.earth/app/uploads/20200129122446/lucyandyak.png',
        link: 'https://x.wp.offset.earth/offset-earth-for-business/attachment/lucyandyak',
        alt: 'Lucy & Yak',
      },
    },
    {
      organisation_name: 'Star Editions',
      organisation_website_link: 'https://stareditions.com/',
      organisation_offset_earth_username: 'stareditions',
      person_name: 'Will Marston, CEO',
      testimony:
        "Ecologi perfectly resonates with our company ethos and we couldn't be prouder to be a part of this movement.",
      image: {
        url: 'https://cms-assets.offset.earth/app/uploads/20200129192700/star-logo-sq.png',
        link: 'https://x.wp.offset.earth/offset-earth-for-business/attachment/star-logo-sq',
        alt: 'Star Editions',
        icon: 'https://x.wp.offset.earth/wp/wp-includes/images/media/default.png',
      },
    },
    {
      organisation_name: 'Great State',
      organisation_website_link: 'https://www.greatstate.co/',
      organisation_offset_earth_username: 'greatstate',
      person_name: 'Victoria James, Director',
      testimony: "Ecologi was an absolute winner with our employees; it received the 'best benefit' award 2019.",
      image: {
        url: 'https://cms-assets.offset.earth/app/uploads/20200129193249/greatstate.png',
        link: 'https://x.wp.offset.earth/offset-earth-for-business/attachment/greatstate',
        alt: 'Great State',
      },
    },
  ],
  title: 'What our customers say',
};
